export const styles = (theme) => ({
    container: {
        minWidth: 200
    },
    title: {
        paddingLeft: theme.miscellaneous.spacing,
        margin: [theme.miscellaneous.spacing, 0]
    }
});
